import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const ProcedureUpdatesTourSteps = [
	{
		selector: '[data-tour="procedure-updates"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Welcome">
					Review and manage improvement suggestions. Use the tabs to switch
					between New, Mine, Verified, and Declined.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="procedure-updates-tree"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Tree">
					Browse procedures and checklists. Select one to see its suggestions in
					the right panel.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="procedure-updates-document"]',
		position: "center",
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Document">
					The checklist steps are shown here. Click a suggestion indicator on a
					step to jump to that suggestion.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="procedure-updates-comments"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Comments">
					Suggestions panel — verify, decline, or add a reply. Use prev/next to
					move between suggestions.
				</Translate>
			</Box>
		),
	},
];

export const getEmbeddedProcedureUpdatesTourSteps = (isMobile: boolean) => [
	{
		selector: '[data-tour="procedure-updates"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Embedded.Welcome">
					Welcome to Improvements. Review new suggestions, sort them by status,
					and process updates without leaving Procedures.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="procedures-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Embedded.PageTabs">
					You are in the Improvements area of Procedures. Use the top page tabs
					to move back to Browse or over to Procedure review.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="procedure-updates-subtabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Embedded.SubTabs">
					These tabs switch between New, My improvements, Verified, and Declined
					so you can focus on the right suggestion queue.
				</Translate>
			</Box>
		),
	},
	{
		selector: isMobile
			? '[data-tour="procedures-folders-button"]'
			: '[data-tour="procedures-folders"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Embedded.Folders">
					Use folders to narrow Improvements , or clear the folder filter to
					review suggestions from everywhere.
				</Translate>
			</Box>
		),
	},
	{
		selector: isMobile
			? '[data-tour="procedure-updates"]'
			: '[data-tour="procedure-updates-comments"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ProcedureUpdates.Embedded.Suggestions">
					This is where you review the active suggestions for the selected
					checklist. Open one, then verify, decline, or comment as you work
					through the queue.
				</Translate>
			</Box>
		),
	},
];
